export default '/home/runner/work/ziti-browzer-core/ziti-browzer-core/node_modules/libsodium/dist/modules'